import templateUrl from 'emun.on-demand/admin/design-publishing-group.htm'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import Media from 'webutils/media/media'


class controller {
    constructor() {
        basicController(this)
        const $ctrl = this;
    }

    $onInit() {
        const $ctrl = this;
        $ctrl.publisher.register($ctrl);
        $ctrl.bus = $ctrl.publisher.bus;
    }

    $onChanges(e){
        const $ctrl = this;
        if(e.tagKind){
            $ctrl.publisher.busy = `Finding ${e.tagKind.currentValue} groups`;
            $ctrl.publisher.bus.send(`QueryProductTemplateTags/${encodeURIComponent(e.tagKind.currentValue)}.json?Active=1`).then(
                res => {
                    $ctrl.publisher.busy = false;
                    $ctrl.groups = res.data.results.map(o => {
                        o.media = new Media({url:o.imageUrl});
                        return o;
                    });
                    $ctrl.analyze();
                },
                e => {
                    $ctrl.publisher.busy = 'No groups'; 
                }
            );
        }
    }

    $onDestroy(){
        const $ctrl = this;
        //$ctrl.bus.dispose(); parent
    }

    analyze() {
        const $ctrl = this;
        $ctrl.groups.selectedLength = $ctrl.groups.filter(o => o.selected).length;
        $ctrl.groups.all = ($ctrl.groups.selectedLength === $ctrl.groups.length);
        $ctrl.groups.any = ($ctrl.groups.selectedLength > 0);
        $ctrl.groups.none = ($ctrl.groups.selectedLength === 0);
    }

    toggle(g) {
        const $ctrl = this;
        if(g){
            g.selected = !g.selected;
        }else{
            $ctrl.groups.forEach(o => o.selected = !$ctrl.groups.all);
        }
        $ctrl.analyze();
    }

    publish() {
        const $ctrl = this;
        let request = {
            designId: $ctrl.publisher.designId,
            tagCriteria: {
                [$ctrl.tagKind]: $ctrl.groups.filter(g => g.selected).map(g => g.tagLabel)
            }
        };
        return $ctrl.publisher.publish(request);
    }
}

let component = {
    bindings: {
        tagKind: '<',
        onPublished: '&',
    },
    require: {
        publisher: '^designPublisher'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default component;